import React, { useEffect, useState } from "react";
import { StarIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";

const InteractiveStarRating = ({
  title = "",
  initialRating,
  onRatingChange,
  disabled,
  position,
}) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState(initialRating || 0);

  useEffect(() => {
    setRating(initialRating || 0);
  }, [initialRating]);

  const handleRatingClick = (value) => {
    if (!disabled) {
      setRating(value);
      if (onRatingChange) {
        onRatingChange(value);
      }
    }
  };

  const getPositionStyle = () => {
    switch (position) {
      case "left":
        return "justify-start";
      case "right":
        return "justify-end";
      default:
        return "justify-center";
    }
  };

  return (
    <div className="flex flex-col gap-2">
      {title && (
        <span className="text-sm font-medium text-gray-700">{t(title)}</span>
      )}
      <div className={`flex ${getPositionStyle()}`}>
        {[1, 2, 3, 4, 5].map((value) => (
          <div
            key={value}
            className={disabled ? "cursor-not-allowed" : "cursor-pointer"}
            onClick={() => handleRatingClick(value)}
          >
            <StarIcon
              className={`h-10 w-10 ${
                value <= rating ? "text-yellow-400" : "text-gray-300"
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InteractiveStarRating;
